import { render, staticRenderFns } from "./PlacesModal.vue?vue&type=template&id=c6af588c&scoped=true"
import script from "./PlacesModal.vue?vue&type=script&lang=js"
export * from "./PlacesModal.vue?vue&type=script&lang=js"
import style0 from "./PlacesModal.vue?vue&type=style&index=0&id=c6af588c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c6af588c",
  null
  
)

export default component.exports